import { render, staticRenderFns } from "./FeedbackEvent.vue?vue&type=template&id=064a001b&scoped=true"
import script from "./FeedbackEvent.vue?vue&type=script&lang=js"
export * from "./FeedbackEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064a001b",
  null
  
)

export default component.exports